/**
 * @file Configuration overrides for the client.
 */

import Modules from '@verosource/myhealth-web/src/constants/modules';

/** @type {import('@verosource/myhealth-web/src/config/appConfig').AppConfig} */
const appConfig = {
  modules: {
    [Modules.LAB_RESULTS]: {
      defaultLowerBoundary: 1,
      absoluteLowerBoundary: new Date(2010, 0),
    },
    [Modules.IMAGING]: {
      defaultLowerBoundary: 12,
      absoluteLowerBoundary: new Date(2023, 5),
    },
    [Modules.MEDICATIONS]: {
      defaultLowerBoundary: 15,
      absoluteLowerBoundary: new Date(2016, 11),
    },
    [Modules.ENCOUNTERS]: {
      defaultLowerBoundary: 12,
      absoluteLowerBoundary: new Date(2011, 6)
    }
  },
};

export default appConfig;
